import actionTypes from "../actionTypes";


const fetchCountries = () => {
  return {
    type: actionTypes.geo.FETCH_COUNTRIES
  };
}

const fetchCountriesOk = (list, estimatedCountryIsoCode) => {
  return {
    type: actionTypes.geo.FETCH_COUNTRIES_OK,
    list: list,
    estimatedCountryIsoCode: estimatedCountryIsoCode
  };
}

const fetchCountriesError = (error) => {
  return {
    type: actionTypes.geo.FETCH_COUNTRIES_ERROR,
    error: error
  };
}


export const geoActions = {
  fetchCountries,
  fetchCountriesOk,
  fetchCountriesError
};